import ParkingValidation from "./pages/ParkingValidation";
import CodeValidation from "./pages/CodeValidation";

const routes = [
  { path: "/", exact: true, name: "Parking Validation", component: ParkingValidation },
  { path: "/touchless", exact: false, name: "Touchless", component: CodeValidation },
];

export default routes;
